import React, {useEffect, useMemo, useState} from 'react';
import {Controller} from "react-hook-form";
import {trafficSourceServices} from "../../service/trafficSourceService";
import {campaignServices} from "../../service/campaignService";
import {Autocomplete, TextField} from "@mui/material";
import {reportingInputStyles, reportingMenuPaperStyles} from "../utils/ReportingToolbarDesign";
import {getSettingsColors} from "../settings/SettingsDesign";

function GroupBySelect(
    {control, watch, campaignId, trafficSourceId, inputName, inputLabel, updateGroupBy, defaultValue, setValue}
) {

    const defaultOptions = useMemo(() => {
        return [
            {label: "Campaign", groupBy: "campaign_id", sortBy: "campaign_id"},
            {label: "Flow", groupBy: "flow_id", sortBy: "flow_id"},
            {label: "Landing", groupBy: "landing_id", sortBy: "landing_id"},
            {label: "Offer", groupBy: "offer_id", sortBy: "offer_id"},
            {label: "Traffic Source", groupBy: "traffic_source_id", sortBy: "traffic_source_id"},
            {label: "Affiliate Network", groupBy: "affiliate_network_id", sortBy: "affiliate_network_id"},
            {label: "Path", groupBy: "path", sortBy: "path"},
            {label: "Country", groupBy: "country", sortBy: "country"},
            {label: "Region", groupBy: "region", sortBy: "region"},
            {label: "City", groupBy: "city", sortBy: "city"},
            {label: "Device Vendor", groupBy: "device_vendor", sortBy: "device_vendor"},
            {label: "Device Model", groupBy: "device_model", sortBy: "device_model"},
            {label: "Device Type", groupBy: "device_type", sortBy: "device_type"},
            {label: "OS", groupBy: "os", sortBy: "os"},
            {label: "OS Version", groupBy: "os_version", sortBy: "os_version"},
            {label: "Browser", groupBy: "browser", sortBy: "browser"},
            {label: "Browser Version", groupBy: "browser_version", sortBy: "browser_version"},
            {label: "Browser Language", groupBy: "browser_language", sortBy: "browser_language"},
            {label: "ISP", groupBy: "isp", sortBy: "isp"},
            {label: "Referrer Domain", groupBy: "referrer_domain", sortBy: "referrer_domain"},
            {label: "Date", groupBy: "date", sortBy: "date"},
            {label: "Day", groupBy: "day", sortBy: "day"},
            {label: "Month", groupBy: "month", sortBy: "month"},
            {label: "Quarter", groupBy: "quarter", sortBy: "quarter"},
            {label: "Year", groupBy: "year", sortBy: "year"},
            {label: "Hour Of Day", groupBy: "hour_of_day", sortBy: "hour_of_day"},
            {label: "Day Of Week", groupBy: "day_of_week", sortBy: "day_of_week"},
            {label: "Day Of Year", groupBy: "day_of_year", sortBy: "day_of_year"},
            {label: "Custom 1", groupBy: "custom1", sortBy: "custom1"},
            {label: "Custom 2", groupBy: "custom2", sortBy: "custom2"},
            {label: "Custom 3", groupBy: "custom3", sortBy: "custom3"},
            {label: "Custom 4", groupBy: "custom4", sortBy: "custom4"},
            {label: "Custom 5", groupBy: "custom5", sortBy: "custom5"},
            {label: "Custom 6", groupBy: "custom6", sortBy: "custom6"},
            {label: "Custom 7", groupBy: "custom7", sortBy: "custom7"},
            {label: "Custom 8", groupBy: "custom8", sortBy: "custom8"},
            {label: "Custom 9", groupBy: "custom9", sortBy: "custom9"},
            {label: "Custom 10", groupBy: "custom10", sortBy: "custom10"},
            {label: "Postback Param 1", groupBy: "postback_param1", sortBy: "postback_param1"},
            {label: "Postback Param 2", groupBy: "postback_param2", sortBy: "postback_param2"},
            {label: "Postback Param 3", groupBy: "postback_param3", sortBy: "postback_param3"},
            {label: "Postback Param 4", groupBy: "postback_param4", sortBy: "postback_param4"},
            {label: "Postback Param 5", groupBy: "postback_param5", sortBy: "postback_param5"}
        ];
    }, []);

    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState(defaultOptions);
    const [search, setSearch] = useState("");
    const [trafficData, setTrafficData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {

        async function fetchData(campaignId, trafficSourceId) {
            try {
                setLoading(true);

                if (campaignId > 0) {
                    const campaign = await campaignServices.find(campaignId);
                    trafficSourceId = campaign?.trafficId;
                }

                const traffic = await trafficSourceServices.find(trafficSourceId);
                setTrafficData(traffic);
                setOptions(defaultOptions.map((item) => {
                    if (item?.groupBy === "custom1") {
                        item.label = "C1: " + traffic?.custom1Name + "";
                        return item;
                    }
                    if (item?.groupBy === "custom2") {
                        item.label = "C2: " + traffic?.custom2Name + "";
                        return item;
                    }
                    if (item?.groupBy === "custom3") {
                        item.label = "C3: " + traffic?.custom3Name + "";
                        return item;
                    }
                    if (item?.groupBy === "custom4") {
                        item.label = "C4: " + traffic?.custom4Name + "";
                        return item;
                    }
                    if (item?.groupBy === "custom5") {
                        item.label = "C5: " + traffic?.custom5Name + "";
                        return item;
                    }
                    if (item?.groupBy === "custom6") {
                        item.label = "C6: " + traffic?.custom6Name + "";
                        return item;
                    }
                    if (item?.groupBy === "custom7") {
                        item.label = "C7: " + traffic?.custom7Name + "";
                        return item;
                    }
                    if (item?.groupBy === "custom8") {
                        item.label = "C8: " + traffic?.custom8Name + "";
                        return item;
                    }
                    if (item?.groupBy === "custom9") {
                        item.label = "C9: " + traffic?.custom9Name + "";
                        return item;
                    }
                    if (item?.groupBy === "custom10") {
                        item.label = "C10: " + traffic?.custom10Name + "";
                        return item;
                    }
                    return item;
                }));
            } catch (e) {
                console.log({e});
            } finally {
                setLoading(false);
            }
        }

        if (open && trafficData === null && (trafficSourceId > 0 || campaignId > 0)) {
            fetchData(campaignId, trafficSourceId);
        }

    }, [defaultOptions, trafficData, open, campaignId, trafficSourceId]);

    const handleSearch = event => {
        setSearch(event.target.value);
    };

    const filteredSelection = () => {
        let selection = [];
        if (!search) {
            options?.forEach(function (item) {
                if (inputName === "groupBy" && watch("groupBy2")?.groupBy === item?.groupBy) {
                } else if (inputName === "groupBy" && watch("groupBy3")?.groupBy === item?.groupBy) {
                } else if (inputName === "groupBy2" && watch("groupBy")?.groupBy === item?.groupBy) {
                } else if (inputName === "groupBy2" && watch("groupBy3")?.groupBy === item?.groupBy) {
                } else if (inputName === "groupBy3" && watch("groupBy")?.groupBy === item?.groupBy) {
                } else if (inputName === "groupBy3" && watch("groupBy2")?.groupBy === item?.groupBy) {
                } else {
                    selection.push(item);
                }
            });
        } else {
            options?.forEach(function (item) {
                if (inputName === "groupBy" && watch("groupBy2")?.groupBy === item?.groupBy) {
                } else if (inputName === "groupBy" && watch("groupBy3")?.groupBy === item?.groupBy) {
                } else if (inputName === "groupBy2" && watch("groupBy")?.groupBy === item?.groupBy) {
                } else if (inputName === "groupBy2" && watch("groupBy3")?.groupBy === item?.groupBy) {
                } else if (inputName === "groupBy3" && watch("groupBy")?.groupBy === item?.groupBy) {
                } else if (inputName === "groupBy3" && watch("groupBy2")?.groupBy === item?.groupBy) {
                } else {
                    selection.push(item);
                }
            });
        }
        return selection;
    };

    useEffect(() => {
        if (!open) {
            setSearch("");
        }
    }, [open]);

    return (
        <Controller
            render={({field: {onChange, ...props}}) => (
                <Autocomplete
                    id={inputName}
                    disableClearable
                    open={open}
                    onOpen={() => {
                        setOpen(true);
                    }}
                    onClose={() => {
                        setOpen(false);
                    }}
                    isOptionEqualToValue={(option, value) => option?.groupBy === value?.groupBy}
                    getOptionLabel={(option) => option?.label}
                    options={filteredSelection()}
                    loading={loading}
                    slotProps={{paper: {sx: {...reportingMenuPaperStyles, width: 'auto'}}}}
                    renderInput={params => <TextField {...params} variant="outlined" size="small"
                        label={inputLabel} placeholder="Select a grouping" onChange={handleSearch}
                        sx={{...reportingInputStyles,
                            '& .MuiOutlinedInput-root.MuiAutocomplete-inputRoot': {
                                bgcolor: theme => theme.palette.mode === 'dark' ? getSettingsColors(theme).inset : theme.palette.background.input
                            }}}
                        slotProps={{inputLabel: {shrink: true}, input: {...params.InputProps},
                            htmlInput: {...params.inputProps, 'aria-label': inputLabel}}}/>}
                    onChange={(e, selectedOption) => {
                        setValue(inputName, selectedOption);
                        updateGroupBy(selectedOption);
                    }}
                    {...props}
                />)}
            onChange={([, data]) => data}
            name={inputName}
            control={control}
            defaultValue={defaultValue}
        />
    );
}

export default GroupBySelect;
